module.exports = __webpack_public_path__ + "static/media/paff-full.9d648277.png";